import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { BiImage } from "react-icons/bi";

export const ListaFirmante = ({ firmante }: any) => {
  return (
    <>
      <ListItemButton sx={{ pl: 4 }}>
        <ListItemAvatar>
          <Avatar>
            <BiImage />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={firmante.nombreFirmante} />
      </ListItemButton>
    </>
  );
};
